import { Observable, of } from 'rxjs';
import {
  AsyncSelectDataSource,
  type AsyncSelectPage,
  type AsyncSelectParams,
} from '@shared/components/async-select-dropdown';

/**
 * Source d'`app-async-select-dropdown` sur une liste deja chargee en memoire : filtre par la
 * recherche, puis decoupe la page demandee. Le composant ne recharge pas de lui-meme quand la
 * liste change : c'est au consommateur de le recreer.
 */
export class SourceSelectEnMemoire<T> extends AsyncSelectDataSource<T> {
  constructor(
    private readonly elements: () => readonly T[],
    private readonly texteRecherche: (element: T) => string,
  ) {
    super();
  }

  load({ query, offset, limit }: AsyncSelectParams): Observable<AsyncSelectPage<T>> {
    const recherche = query.trim().toLowerCase();
    const correspondants = recherche
      ? this.elements().filter(element => (this.texteRecherche(element) ?? '').toLowerCase().includes(recherche))
      : this.elements();
    return of({ items: correspondants.slice(offset, offset + limit), total: correspondants.length });
  }
}
